import React, { useState, createContext, useContext } from 'react';
export type Role = 'superadmin' | 'medico' | 'paziente';
interface RoleContextType {
  role: Role;
  setRole: (role: Role) => void;
}
const RoleContext = createContext<RoleContextType | undefined>(undefined);
export function RoleProvider({
  children
}: {
  children: ReactNode;
}) {
  // Default to superadmin for the demo
  const [role, setRole] = useState<Role>('superadmin');
  return <RoleContext.Provider value={{
    role,
    setRole
  }} data-id="element-257">
      {children}
    </RoleContext.Provider>;
}
export function useRole() {
  const context = useContext(RoleContext);
  if (context === undefined) {
    throw new Error('useRole must be used within a RoleProvider');
  }
  return context;
}